export const localeAr = {
  gloabl: {
    name: "اسم",
    details: "تفاصيل",
    selectMenu: "اختر قائمة",
    select: "اختر...",
    search: "ابحث..",
    new: "جديد",
    common: "شائع",
    recently: "احدث",
    unavailable: "غير متوفر",
    connectUs: "تواصلوا معنا ",
    branchInfo: " معلومات الفرع ",
    changeLang: "تغير اللغة ",
    isNotActive: "المطعم غير فعال ",
    options: "الخيارات :",
    ProducedBy: "مشغل بواسطة    ",
    AllRightsReserved: "جميع الحقوق محفوظة   ",
    totalPrice: "السعر الكلي",
    total: "المجموع",
    branches: "الفروع",
    ourBranches: "فروعنا",
    welcome: "مرحبا بكم في ",
    getOfferNow: `احصل على Premium: عرض خاص!`,
    getUpTo:
      "استمتع بكامل إمكانيات منصتنا الرقمية للقوائم، مع ميزات متقدمة، بسعر لا يُضاهى. عرض لفترة محدودة!",
    getOffer: "احصل على العرض ",
    AED: "د.إ",
    menus: "القوائم",
    homepage: "الرئيسية",
    info: "معلومات",
    close: "اغلاق",
    AddToCart: "اضافة إلى السلة",
    Cart: "السلة",
    checkout: "طلب",
    addNote: "اضافة ملاحظة",
    emptyCart: "سلتك فارغة",
    emptyCartMessage: "يبدو انك لم تضف اي عناصر إلى سلتك بعد !",
    browseProducts: "استعرض المنتجات",
    orders: "الطلبات",
    ordersMessage: "لا يوجد طلبات حتى الان",
    noOrders: "لا يوجد طلبات",
    Settings: "الاعدادات",
    theme: "الوضع",
    verification: "تم إرسال رمز التحقق إلى",
    send: "إرسال",
    resend: "اعادة الارسال",
    otp: "رمز التحقق",
    in: "في",
    s: "ثانية",
    Invalid: "رمز التحقق خطأ او منتهي الصلاحية",
    orderSuccess: "تم الطلب بنجاح, رقم الطلب ",
    orderError: "حدث خطأ في الطلب, يرجى المحاولة مرة أخرى",
    addedToCart: "تم اضافة المنتج الى السلة",
    clickToCart: "انقر للذهاب الى السلة",
    phoneOrName: "الرجاء ادخال رقم الهاتف و الاسم",
    phoneInvalid: "الرجاء ادخال رقم هاتف صحيح",
    order: "طلب",
    orderDetails: "تفاصيل الطلب",
    value: "القيمة",
    Notes: "ملاحظات",
    note: "ملاحظة",
    date: "التاريخ",
    pending: "قيد الانتظار",
    inProcess: "قيد التنفيذ",
    ready: "مكتمل",
    status: "الحالة",
    canselled: "ملغي",
    noNotes: "لا يوجد ملاحظات",
    items: "المنتجات",
    quantity: "الكمية",
    showAllOrders: "اظهار كل الطلبات",
    noResult: "لا يوجد نتائج",
    loading: "جاري التحميل",
    CustomerName: "اسم الزبون",
    CustomerPhone: "هاتف الزبون",

  },
  orderStatus: {
    pending: "قيد الانتظار",
    processing: "قيد التنفيذ",
    completed: "منجز",
    canseled: "ملغي",
    progress: "قيد التنفيذ",
    cancelled: "ملغي",
  },
  //////////////////////
  pages: {
    contact: "تواصل ",
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
    features: "الميزات",
    services: "الخدمات",
    pricing: "الاسعار",
    aboutUs: "من نحن",
    home: "الرئيسية",
    notFound: "صفحة غير موجودة",
    deleteAccountGuide: "طريقة حذف الحساب",
    getStarted: "ابدأ",
    menu: "القائمة",
  },
  deleteAccountGuide: {
    title: "كيفية حذف الحساب",
    subtitle: "اتبع الخطوات التالية لحذف حسابك من التطبيق",
    step1Title: "افتح القائمة",
    step1Desc: "من الصفحة الرئيسية اضغط على أيقونة القائمة (≡) في الأعلى.",
    step2Title: "اختر حذف الحساب",
    step2Desc: "من القائمة الجانبية اختر خيار حذف الحساب.",
    step3Title: "أكد الحذف",
    step3Desc: "اختر سبب الحذف ثم اضغط على زر حذف لتأكيد العملية.",
    noteTitle: "ملاحظة",
    noteText: "حذف الحساب إجراء نهائي ولا يمكن التراجع عنه.",
  },
  HomePage: {
    // Hero Section
    heroTitle: "مطعم كريش",
    heroSubtitle: "مطعم سوري شهير للوجبات السريعة",
    heroDescription: "شق طريقه إلى الشارقة في عام 2012، وافتتح فرعه الثاني في عجمان عام 2020. تحتوي قائمتنا على الشاورما اللذيذة والبرغر وسندويشات الدجاج التي من المؤكد أنها سترضي أي شهية.",
    browseMenu: "تصفح قائمتنا",
    orderNow: "اطلبها الآن",

    // About Section
    aboutTitle: "من نحن",
    aboutDescription: "مطعم كريش هو مطعم سوري شهير للوجبات السريعة شق طريقه إلى الشارقة في عام 2012، وافتتح فرعه الثاني في عجمان عام 2020. تحتوي قائمتنا على الشاورما اللذيذة والبرغر وسندويشات الدجاج التي من المؤكد أنها سترضي أي شهية. قم بزيارتنا اليوم لتجربة مذاق المطبخ السوري الأصيل.",

    // Branches Section
    branchesTitle: "فروعنا",
    branchesSubtitle: "زورونا في أحد فروعنا",
    branchAddress: "العنوان",
    branchPhone: "الهاتف",
    branchMobile: "الجوال",
    branchWhatsapp: "واتساب",
    viewOnMap: "عرض على الخريطة",
    workingHours: "ساعات العمل",
    dailyHours: "يومياً من 11 صباحاً حتى 1 مساءً",

    // Features Section
    featuresTitle: "لماذا تختار كريش؟",
    freshFood: "طعام طازج",
    freshFoodDesc: "نستخدم أجود المكونات الطازجة في جميع أطباقنا",
    authenticTaste: "طعم أصيل",
    authenticTasteDesc: "نقدم المذاق الأصيل للمطبخ السوري",
    fastService: "خدمة سريعة",
    fastServiceDesc: "نضمن تقديم طلبك بسرعة وكفاءة",

    // App Download Section
    appDownloadTitle: "حمّل تطبيقنا الآن",
    appDownloadSubtitle: "اطلب طعامك المفضل بسهولة من خلال تطبيقنا",
    appDownloadDescription: "استمتع بتجربة طلب سريعة وسهلة. اطلب من أي مكان وفي أي وقت واحصل على عروض حصرية!",
    downloadNow: "حمّل الآن",
    availableOn: "متوفر على",

  },

  contact: {
    sendMessage: "ارسال رسالة",
    name: "الاسم",
    email: "البريد الالكتروني",
    subject: "الموضوع",
    message: "الرسالة",
    send: "ارسال",
    phone: "الهاتف",
    sendMassageParagraph: "يسعدنا التواصل معك! يُرجى تعبئة النموذج أدناه.",
    ReachOutDirectly: "اتصل بنا مباشرة",
    ConnectWithUs: "اتصل بنا",
  },
  footer: {
    allRightsReserved: "جميع الحقوق محفوظة",
    ProducedBy: "منتج بواسطة",
    qickLinks: "روابط سريعة",
    contactUs: "اتصل بنا",
  },
  ////////////////////////////////////
  PrivacyPolicy: {
    title: "سياسة الخصوصية",
  },
  /////////////////////////////////////////////////////////////////////////////
  //  End Privacy Policy
  /////////////////////////////////////////////////////////////////////////////
  Terms: {
    title: "شروط الخدمة",
  },
  order: {
    success: {
      title: "تم استلام طلبك بنجاح!",
      message: "شكراً لك! تم استلام طلبك وسيتم معالجته قريباً",
      orderNumber: "رقم الطلب",
      estimatedTime: "الوقت المتوقع للتوصيل",
      backToHome: "العودة إلى الصفحة الرئيسية",
    },
    failed: {
      title: "فشل في معالجة الطلب",
      message: "عذراً، حدث خطأ أثناء معالجة طلبك. يرجى المحاولة مرة أخرى",
      reason: "السبب",
      tryAgain: "حاول مرة أخرى",
      backToHome: "العودة إلى الصفحة الرئيسية",
    },
  },
  notFound: {
    title: "404",
    heading: "الصفحة غير موجودة",
    message: "عذراً، الصفحة التي تبحث عنها غير موجودة",
    backToHome: "العودة إلى الصفحة الرئيسية",
  },
};
